import { render, staticRenderFns } from "./postImage.vue?vue&type=template&id=55b59400&"
import script from "./postImage.vue?vue&type=script&lang=js&"
export * from "./postImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports